export const FORM_FACTORS = {
  DESKTOP: 'desktop',
  PHONE: 'phone',
  TABLET: 'tablet'
};

// Intl formats to be used in the IntlProvider
export const intlFormats = {
  number: {
    currency: {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: 0
    }
  }
};
